var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "div",
        { staticClass: "q-display-1 q-mb-md text-secondary" },
        [
          _c("q-icon", {
            staticClass: "q-mb-sm",
            attrs: { name: "far fa-question-circle" }
          }),
          _vm._v(" " + _vm._s(_vm.$t(_vm.title_faq)) + "\n        ")
        ],
        1
      ),
      _c("filters", {
        staticClass: "filter-card",
        attrs: { options: _vm.getOptionsFilter },
        on: {
          requestFiltered: _vm.requestFiltered,
          clearAndRequest: _vm.clearAndRequest
        }
      }),
      _c("q-table", {
        attrs: {
          data: _vm.faqs,
          columns: _vm.columns,
          pagination: _vm.server_pagination,
          loading: _vm.loading,
          filter: _vm.filter,
          "row-key": "name",
          "no-data-label": _vm.$t("no_data_avaliable"),
          "no-results-label": _vm.$t("no_results_found"),
          "loading-label": _vm.$t("loading_data"),
          "rows-per-page-label": _vm.$t("items_per_page"),
          "rows-per-page-options": [5, 10, 50, 100],
          "binary-state-sort": ""
        },
        on: {
          "update:pagination": function($event) {
            _vm.server_pagination = $event
          },
          request: _vm.request
        },
        scopedSlots: _vm._u([
          {
            key: "top",
            fn: function(props) {
              return [
                _c("q-search", {
                  attrs: {
                    icon: "fas fa-search",
                    placeholder: _vm.$t("search"),
                    debounce: 500
                  },
                  model: {
                    value: _vm.filter,
                    callback: function($$v) {
                      _vm.filter = $$v
                    },
                    expression: "filter"
                  }
                }),
                _c("div", { staticClass: "col" }),
                _c("q-btn", {
                  attrs: {
                    color: "secondary",
                    icon: "fas fa-plus",
                    label: _vm.$t("new")
                  },
                  on: {
                    click: function($event) {
                      return _vm.$router.push({
                        name: "admin_faq",
                        params: { id: 0 }
                      })
                    }
                  }
                })
              ]
            }
          },
          {
            key: "header",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                _vm._l(props.cols, function(col) {
                  return _c(
                    "q-th",
                    { key: col.name, attrs: { props: props } },
                    [
                      col.name == "is_public" && _vm.show_public_faq
                        ? _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t(col.label)) +
                                "\n                    "
                            )
                          ])
                        : _vm._e(),
                      col.name != "is_public"
                        ? _c("div", [
                            _vm._v(
                              "\n                        " +
                                _vm._s(_vm.$t(col.label)) +
                                "\n                    "
                            )
                          ])
                        : _vm._e()
                    ]
                  )
                }),
                1
              )
            }
          },
          {
            key: "body",
            fn: function(props) {
              return _c(
                "q-tr",
                { attrs: { props: props } },
                [
                  _c(
                    "q-td",
                    { key: "id", attrs: { "auto-width": "", props: props } },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(props.row.id) +
                          "\n                "
                      )
                    ]
                  ),
                  _c("q-td", { key: "question", attrs: { props: props } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(props.row.question) +
                        "\n                "
                    )
                  ]),
                  _c("q-td", { key: "faq_category", attrs: { props: props } }, [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.getFaqCategory(props.row.faq_category)) +
                        "\n                "
                    )
                  ]),
                  _c(
                    "q-td",
                    {
                      key: "status",
                      attrs: { props: props, "auto-width": "" }
                    },
                    [
                      _c(
                        "q-chip",
                        {
                          staticClass: "full-width",
                          attrs: {
                            small: "",
                            icon: _vm.getIconStatus(props.row.status),
                            color: _vm.getColorStatus(props.row.status)
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t(_vm.getStatus(props.row.status))) +
                              "\n                    "
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm.show_public_faq
                    ? _c(
                        "q-td",
                        {
                          key: "is_public",
                          attrs: { props: props, "auto-width": "" }
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(
                                props.row.is_public
                                  ? _vm.$t("yes")
                                  : _vm.$t("no")
                              ) +
                              "\n                "
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "q-td",
                    { key: "actions", attrs: { props: props } },
                    [
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "primary",
                            icon: "fas fa-pencil-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.$router.push({
                                name: "admin_faq",
                                params: { id: props.row.actions }
                              })
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("view_or_edit_tooltip")) +
                                "\n                        "
                            )
                          ])
                        ],
                        1
                      ),
                      _c(
                        "q-btn",
                        {
                          attrs: {
                            flat: "",
                            round: "",
                            color: "negative",
                            icon: "far fa-trash-alt"
                          },
                          on: {
                            click: function($event) {
                              return _vm.confirmRemove(props.row.actions)
                            }
                          }
                        },
                        [
                          _c("q-tooltip", [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("delete_tooltip")) +
                                "\n                        "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            }
          }
        ])
      }),
      _c(
        "q-dialog",
        {
          on: { ok: _vm.removeItem },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "primary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        _vm.confirm_remove = false
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: { color: "negative", label: _vm.$t("remove") },
                    on: {
                      click: function($event) {
                        return _vm.removeItem()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_remove,
            callback: function($$v) {
              _vm.confirm_remove = $$v
            },
            expression: "confirm_remove"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t("remove_item")))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(_vm._s(_vm.$t("confirm_remove_item")))
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }